import React from "react";
import { useTranslation } from 'react-i18next';
import cookies from 'js-cookie'


import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import PageTitle from "cms/blocks/common/PageTitle";
import PageSideMenu from "../common/PageSideMenu";
import DOMPurify from "isomorphic-dompurify";

require("styles/components/common/single-page.scss");
require("styles/components/common/typography.scss");

const FAQs = ({block,full_layout,...props}) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const currentLanguageCode = cookies.get('i18next') || 'en';

  const { data, settings } = block;

  return (
    <>

      <div className="single-page page-with-right-full-bg">
        <PageTitle data={full_layout?.content?.bidaya_content} />

        <div className="container">
          <div className="row">

            <div className="col-12 col-sm-2 col-page-side-menu">
            <PageSideMenu current={full_layout?.content?.bidaya_content?.entity?.title[0]?.value} data={full_layout?.header?.contactussidemenu?.data}/>
            </div>

            <div className="col-12 col-sm-10 col-content col-accordions col-content page-with-right-full-bg__parent">
              <div className='page-with-right-full-bg__content'>
              <div className='right-block-content'>
              {data?.field_q_a?.filter(d => d.title != 'NULL').sort((a, b) => a.target_id > b.target_id ? 1:-1).map((item, pos) => {
                return (
                  <Accordion key={pos} expanded={expanded === pos} onChange={handleChange(pos)} elevation={0}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel4bh-header"
                    >
                      { (currentLanguageCode === 'ar') ? item.title : item.title }
                    </AccordionSummary>
                    <AccordionDetails className="typography" dangerouslySetInnerHTML={{ __html: (currentLanguageCode === 'ar') ? DOMPurify.sanitize(item?.body) : DOMPurify.sanitize(item?.body) }}>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
              </div>
              </div>
           
            </div>
          
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQs;
